@if (turnstileService.verified()) {
  <a class="demo-skip-link" href="#demo-main">Saltar al contenido</a>
  <demo-header />
  <main id="demo-main" tabindex="-1">
    <router-outlet />
  </main>
  <demo-footer />
} @else {
  <demo-turnstile-gate />
}
